import React from "react";
import { Position } from "@xyflow/react";

import { KgFlowHandle } from "../../../atoms/KgFlowHandle";
import { KG_HANDLE_IDS } from "../utils/kgEdgeHandles";

export type KgFlowNodeHandlesProps = {
  /** Visible ports for manual relationship drawing (data model builder). */
  visible?: boolean;
  /**
   * `dataModel` — source + target on all four sides so lines can start/end on any port.
   * `kg` — KG auto-layout ports (left/top in, right/bottom out).
   */
  variant?: "kg" | "dataModel";
};

const KgCanvasHandles: React.FC<{ visible: boolean }> = ({ visible }) => (
  <>
    <KgFlowHandle
      id={KG_HANDLE_IDS.targetLeft}
      type="target"
      position={Position.Left}
      visible={visible}
    />
    <KgFlowHandle
      id={KG_HANDLE_IDS.targetTop}
      type="target"
      position={Position.Top}
      visible={visible}
    />
    <KgFlowHandle
      id={KG_HANDLE_IDS.sourceRight}
      type="source"
      position={Position.Right}
      visible={visible}
    />
    <KgFlowHandle
      id={KG_HANDLE_IDS.sourceBottom}
      type="source"
      position={Position.Bottom}
      visible={visible}
    />
  </>
);

const DataModelBuilderHandles: React.FC<{ visible: boolean }> = ({ visible }) => (
  <>
    <KgFlowHandle
      id={KG_HANDLE_IDS.sourceLeft}
      type="source"
      position={Position.Left}
      visible={visible}
    />
    <KgFlowHandle
      id={KG_HANDLE_IDS.targetLeft}
      type="target"
      position={Position.Left}
      visible={visible}
    />
    <KgFlowHandle
      id={KG_HANDLE_IDS.sourceTop}
      type="source"
      position={Position.Top}
      visible={visible}
    />
    <KgFlowHandle
      id={KG_HANDLE_IDS.targetTop}
      type="target"
      position={Position.Top}
      visible={visible}
    />
    <KgFlowHandle
      id={KG_HANDLE_IDS.sourceRight}
      type="source"
      position={Position.Right}
      visible={visible}
    />
    <KgFlowHandle
      id={KG_HANDLE_IDS.targetRight}
      type="target"
      position={Position.Right}
      visible={visible}
    />
    <KgFlowHandle
      id={KG_HANDLE_IDS.sourceBottom}
      type="source"
      position={Position.Bottom}
      visible={visible}
    />
    <KgFlowHandle
      id={KG_HANDLE_IDS.targetBottom}
      type="target"
      position={Position.Bottom}
      visible={visible}
    />
  </>
);

/**
 * Connection ports per node. KG canvas uses four directional handles; the data model
 * builder uses eight (source + target on each side) for flexible manual drawing.
 */
export const KgFlowNodeHandles: React.FC<KgFlowNodeHandlesProps> = ({
  visible = false,
  variant = "kg",
}) =>
  variant === "dataModel" ? (
    <DataModelBuilderHandles visible={visible} />
  ) : (
    <KgCanvasHandles visible={visible} />
  );

export default KgFlowNodeHandles;
